import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useMemo, useState } from 'react';
import { db } from '../firebase';
import { ChurchEntitlement } from '../models/ChurchEntitlement';
import { useUser } from './useUser';

export function useChurchEntitlement(churchId?: string) {
  const user = useUser();
  const [entitlement, setEntitlement] = useState<ChurchEntitlement>();
  const [loading, setLoading] = useState(Boolean(churchId));
  const [error, setError] = useState('');
  const [loadedKey, setLoadedKey] = useState('');
  const requestKey = `${user?.uid || ''}:${churchId || ''}`;

  useEffect(() => {
    if (!churchId || !user || user.isAnonymous) {
      setEntitlement(undefined);
      setLoading(false);
      return;
    }
    setLoading(true);
    setEntitlement(undefined);
    setError('');
    return onSnapshot(
      doc(db, 'entitlements', churchId),
      (snapshot) => {
        setEntitlement(snapshot.exists() ? snapshot.data() as ChurchEntitlement : undefined);
        setLoading(false);
        setLoadedKey(requestKey);
      },
      (nextError) => {
        setError(nextError.message);
        setLoading(false);
        setLoadedKey(requestKey);
      },
    );
  }, [churchId, user?.uid, user?.isAnonymous, requestKey]);

  const hasAccess = useMemo(() => {
    const accessUntil = entitlement?.accessUntil?.toMillis?.() || 0;
    return entitlement?.accessGranted === true && accessUntil > Date.now();
  }, [entitlement]);

  return { entitlement, hasAccess, loading: loading ||
    Boolean(churchId && user && !user.isAnonymous && loadedKey !== requestKey), error };
}
